// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-container {
  display: flex;
  flex-direction: row;
  height: 80vh;
  width: auto;
  background-color: #ffffff;
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  color: #000000;
  overflow: hidden;
}
.chat-container .sidebar {
  width: 280px;
  padding: 16px 12px;
  background: #fcfcfc;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  scrollbar-color: #ffffff #ffffff;
  position: relative;
  border-right: 1px solid #d1d5db;
  flex-shrink: 0;
  transition: transform 0.3s ease, visibility 0.3s ease;
}
.chat-container .sidebar .new-chat-btn {
  margin-bottom: 24px;
  width: fit-content;
  padding: 12px 18px;
  border-radius: 24px;
  background: #f0f0f2;
  color: #000000;
  font-weight: 500;
  font-size: 14px;
  border: 1px solid #d1d5db;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.2s ease;
}
.chat-container .sidebar .new-chat-btn:hover {
  background-color: #e4e4e7;
}
.chat-container .sidebar .new-chat-btn span {
  font-size: 20px;
  line-height: 1;
  color: #000000;
}
.chat-container .sidebar .recent-header {
  padding-left: 12px;
  margin-bottom: 12px;
}
.chat-container .sidebar .recent-header span {
  font-weight: 500;
  font-size: 13px;
  color: #374151;
  letter-spacing: 0.01em;
}
.chat-container .sidebar .search-wrapper {
  position: relative;
  margin-bottom: 16px;
  padding: 0 4px;
}
.chat-container .sidebar .search-wrapper .search-input {
  width: 100%;
  padding: 10px 16px;
  border-radius: 20px;
  border: 1px solid #d1d5db;
  background-color: transparent;
  font-size: 14px;
  color: #000000;
  outline: none;
  box-sizing: border-box;
}
.chat-container .sidebar .search-wrapper .search-input::placeholder {
  color: #374151;
  opacity: 0.7;
}
.chat-container .sidebar .heads-container {
  flex: 1 1;
  color: #000000;
}
.chat-container .sidebar .heads-container * {
  color: #000000 !important;
  background-color: transparent !important;
}
.chat-container .chat-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  background: #ffffff;
  min-width: 0;
}
.chat-container .chat-content.is-empty {
  justify-content: center;
}
.chat-container .chat-content.is-empty .timeline-stream {
  display: none !important;
}
.chat-container .chat-content.is-empty .action-hub {
  padding-top: 0;
}
.chat-container .chat-content.is-empty .action-hub .landing-welcome-hero {
  display: block;
}
.chat-container .chat-content:not(.is-empty) {
  justify-content: space-between;
}
.chat-container .chat-content:not(.is-empty) .timeline-stream {
  display: flex;
}
.chat-container .chat-content:not(.is-empty) .action-hub .landing-welcome-hero {
  display: none !important;
}
.chat-container .chat-content .top-navbar {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
  padding: 12px 24px;
  z-index: 10;
  color: #000000;
  flex-shrink: 0;
}
.chat-container .chat-content .top-navbar * {
  color: #000000 !important;
}
.chat-container .chat-content .timeline-stream {
  flex: 1 1;
  position: relative;
  background: #ffffff;
  overflow-y: auto;
  display: flex;
  justify-content: center;
}
.chat-container .chat-content .timeline-stream .reading-track {
  width: 100%;
  max-width: 820px;
  padding: 24px 24px;
}
.chat-container .chat-content .timeline-stream .reading-track .message-text {
  font-size: 16px;
  line-height: 1.62;
  color: #000000;
}
.chat-container .chat-content .timeline-stream .reading-track span, .chat-container .chat-content .timeline-stream .reading-track a, .chat-container .chat-content .timeline-stream .reading-track div, .chat-container .chat-content .timeline-stream .reading-track p {
  color: #000000 !important;
}
.chat-container .chat-content .timeline-stream .reading-track a {
  text-decoration: underline;
  opacity: 0.9;
}
.chat-container .chat-content .action-hub {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 24px;
  padding-top: 8px;
  width: 100%;
  flex-shrink: 0;
}
.chat-container .chat-content .action-hub .landing-welcome-hero {
  display: none;
  text-align: center;
  margin-bottom: 24px;
  max-width: 680px;
  padding: 0 24px;
  animation: heroFadeIn 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.chat-container .chat-content .action-hub .landing-welcome-hero h1 {
  font-size: 32px;
  font-weight: 500;
  color: #000000;
  margin-bottom: 12px;
  letter-spacing: -0.02em;
}
.chat-container .chat-content .action-hub .landing-welcome-hero .subtitle-suggestion {
  font-size: 14px;
  color: #374151;
  line-height: 1.5;
  background: #f0f0f2;
  padding: 10px 16px;
  border-radius: 16px;
  display: inline-block;
  border: 1px solid #d1d5db;
}
.chat-container .chat-content .action-hub .input-max-width {
  width: 100%;
  max-width: 820px;
  padding: 0 24px;
  box-sizing: border-box;
}
.chat-container .chat-content .action-hub .upload-pills {
  margin-bottom: 12px;
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px;
  background: #f0f0f2;
  border-radius: 16px;
  border: 1px solid #d1d5db;
}
.chat-container .chat-content .action-hub .upload-pills .file-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  max-width: 80px;
}
.chat-container .chat-content .action-hub .upload-pills .file-preview img, .chat-container .chat-content .action-hub .upload-pills .file-preview video {
  width: 64px;
  height: 64px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid #d1d5db;
}
.chat-container .chat-content .action-hub .upload-pills .file-preview .file-name {
  font-size: 11px;
  color: #374151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  text-align: center;
  margin-top: 6px;
}
.chat-container .chat-content .action-hub .input-wrapper {
  position: relative;
  border-radius: 28px;
  background-color: #f0f0f2;
  padding: 8px 16px;
  color: #000000;
  border: 1px solid #d1d5db;
  box-sizing: border-box;
}
.chat-container .chat-content .action-hub .input-wrapper * {
  color: #000000 !important;
  fill: #000000 !important;
}
.chat-container .chat-content .action-hub .input-wrapper input, .chat-container .chat-content .action-hub .input-wrapper textarea {
  color: #000000 !important;
  background-color: transparent !important;
}
.chat-container .chat-content .action-hub .input-wrapper input::placeholder, .chat-container .chat-content .action-hub .input-wrapper textarea::placeholder {
  color: #374151 !important;
  opacity: 0.6;
}
.chat-container .chat-content .action-hub .footer-disclaimer {
  text-align: center;
  font-size: 12px;
  color: #374151;
  margin-top: 12px;
  letter-spacing: 0.01em;
  opacity: 0.8;
}
@media (max-width: 768px) {
  .chat-container {
    padding-top: 56px;
    height: calc(100vh - 56px);
  }
  .chat-container .sidebar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    z-index: 100;
    transform: translateX(-100%);
    visibility: hidden;
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);
  }
  .chat-container .sidebar.is-open {
    transform: translateX(0);
    visibility: visible;
  }
  .chat-container .chat-content .top-navbar {
    padding: 12px 16px;
  }
  .chat-container .chat-content .timeline-stream .reading-track {
    padding: 16px 16px;
  }
  .chat-container .chat-content .timeline-stream .reading-track .message-text {
    font-size: 15px;
  }
  .chat-container .chat-content .action-hub {
    padding-bottom: 16px;
  }
  .chat-container .chat-content .action-hub .landing-welcome-hero {
    padding: 0 16px;
  }
  .chat-container .chat-content .action-hub .landing-welcome-hero h1 {
    font-size: 24px;
  }
  .chat-container .chat-content .action-hub .input-max-width {
    padding: 0 12px;
  }
}

@keyframes heroFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.reading-track {
  width: 100%;
  max-width: 820px;
  padding: 24px 24px;
}
@media (max-width: 768px) {
  .reading-track {
    padding: 16px 16px;
  }
}
.reading-track .markdown-content {
  font-size: 16px;
  line-height: 1.65;
  color: #000000;
}
@media (max-width: 768px) {
  .reading-track .markdown-content {
    font-size: 15px;
  }
}
.reading-track .markdown-content p {
  margin-top: 0;
  margin-bottom: 12px;
}
.reading-track .markdown-content strong {
  font-weight: 600;
  color: #000000;
}
.reading-track .markdown-content ul, .reading-track .markdown-content ol {
  margin-top: 4px;
  margin-bottom: 12px;
  padding-left: 20px;
}
.reading-track .markdown-content ul li, .reading-track .markdown-content ol li {
  margin-bottom: 6px;
}
.reading-track .markdown-content ul {
  list-style-type: disc;
}
.reading-track .markdown-content ol {
  list-style-type: decimal;
}
.reading-track .markdown-content code {
  font-family: monospace;
  background-color: #f0f0f2;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/ai/AIChatView.scss"],"names":[],"mappings":"AAcA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAlBe;EAmBf,qDAXY;EAYZ,cAfiB;EAgBjB,gBAAA;AAbF;AAgBE;EACE,YAAA;EACA,kBAAA;EACA,mBA1BgB;EA2BhB,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gCAAA;EACA,kBAAA;EACA,+BAAA;EACA,cAAA;EACA,qDAAA;AAdJ;AAgBI;EACE,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAxCW;EAyCX,cAtCa;EAuCb,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sCAAA;AAdN;AAgBM;EACE,yBAnDe;AAqCvB;AAiBM;EACE,eAAA;EACA,cAAA;EACA,cAvDW;AAwCnB;AAmBI;EACE,kBAAA;EACA,mBAAA;AAjBN;AAmBM;EACE,gBAAA;EACA,eAAA;EACA,cAjEa;EAkEb,sBAAA;AAjBR;AAqBI;EACE,kBAAA;EACA,mBAAA;EACA,cAAA;AAnBN;AAqBM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;EACA,cAnFW;EAoFX,aAAA;EACA,sBAAA;AAnBR;AAqBQ;EACE,cAvFW;EAwFX,YAAA;AAnBV;AAwBI;EACE,SAAA;EACA,cAhGa;AA0EnB;AAwBM;EACE,yBAAA;EACA,wCAAA;AAtBR;AA4BE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBArHa;EAsHb,YAAA;AA1BJ;AA4BI;EACE,uBAAA;AA1BN;AA4BM;EACE,wBAAA;AA1BR;AA6BM;EACE,cAAA;AA3BR;AA4BQ;EACE,cAAA;AA1BV;AA+BI;EACE,8BAAA;AA7BN;AA+BM;EACE,aAAA;AA7BR;AAiCQ;EACE,wBAAA;AA/BV;AAoCI;EACE,oCAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,cArJa;EAsJb,cAAA;AAlCN;AAoCM;EACE,yBAAA;AAlCR;AAsCI;EACE,SAAA;EACA,kBAAA;EACA,mBArKW;EAsKX,gBAAA;EACA,aAAA;EACA,uBAAA;AApCN;AAsCM;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AApCR;AAsCQ;EACE,eAAA;EACA,iBAAA;EACA,cA7KS;AAyInB;AAuCQ;EACE,yBAAA;AArCV;AAwCQ;EACE,0BAAA;EACA,YAAA;AAtCV;AA2CI;EACE,mBAjMW;EAkMX,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;AAzCN;AA2CM;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,0DAAA;AAzCR;AA2CQ;EACE,eAAA;EACA,gBAAA;EACA,cAhNS;EAiNT,mBAAA;EACA,uBAAA;AAzCV;AA4CQ;EACE,eAAA;EACA,cAtNW;EAuNX,gBAAA;EACA,mBA5NO;EA6NP,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;AA1CV;AA8CM;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;AA5CR;AA+CM;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,mBAjPS;EAkPT,mBAAA;EACA,yBAAA;AA7CR;AA+CQ;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA7CV;AA+CU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;AA7CZ;AAgDU;EACE,eAAA;EACA,cAlQS;EAmQT,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AA9CZ;AAmDM;EACE,kBAAA;EACA,mBAAA;EACA,yBApRS;EAqRT,iBAAA;EACA,cAnRW;EAoRX,yBAAA;EACA,sBAAA;AAjDR;AAmDQ;EACE,yBAAA;EACA,wBAAA;AAjDV;AAoDQ;EACE,yBAAA;EACA,wCAAA;AAlDV;AAoDU;EACE,yBAAA;EACA,YAAA;AAlDZ;AAuDM;EACE,kBAAA;EACA,eAAA;EACA,cAzSa;EA0Sb,gBAAA;EACA,sBAAA;EACA,YAAA;AArDR;AA6DE;EA7SF;IA8SI,iBAAA;IACA,0BAAA;EA1DF;EA4DE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,YAAA;IACA,4BAAA;IACA,kBAAA;IACA,0CAAA;EA1DJ;EA4DI;IACE,wBAAA;IACA,mBAAA;EA1DN;EA+DI;IACE,kBAAA;EA7DN;EAiEM;IACE,kBAAA;EA/DR;EAiEQ;IACE,eAAA;EA/DV;EAoEI;IACE,oBAAA;EAlEN;EAoEM;IACE,eAAA;EAlER;EAoEQ;IACE,eAAA;EAlEV;EAsEM;IACE,eAAA;EApER;AACF;;AA0EA;EACE;IACE,UAAA;IACA,0BAAA;EAvEF;EAyEA;IACE,UAAA;IACA,wBAAA;EAvEF;AACF;AA0EA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;AAxEF;AA0EE;EALF;IAMI,kBAAA;EAvEF;AACF;AAyEE;EACE,eAAA;EACA,iBAAA;EACA,cAlYe;AA2TnB;AAyEI;EALF;IAMI,eAAA;EAtEJ;AACF;AAwEI;EACE,aAAA;EACA,mBAAA;AAtEN;AAyEI;EACE,gBAAA;EACA,cAAA;AAvEN;AA0EI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AAxEN;AA0EM;EACE,kBAAA;AAxER;AA4EI;EACE,qBAAA;AA1EN;AA6EI;EACE,wBAAA;AA3EN;AA8EI;EACE,sBAAA;EACA,yBAzaW;EA0aX,gBAAA;EACA,kBAAA;EACA,eAAA;AA5EN","sourcesContent":["// Gemini Light Theme Variables - Absolute Pure Contrast Lock\n$gemini-bg-main: #ffffff;\n$gemini-bg-sidebar: #fcfcfc;\n$gemini-bg-pill: #f0f0f2;\n$gemini-bg-pill-hover: #e4e4e7;\n$gemini-bg-input: #ffffff;\n$gemini-text-main: #000000;\n$gemini-text-subtle: #374151;\n$gemini-border-color: #d1d5db;\n$gemini-font: \"Google Sans\", Roboto, Arial, sans-serif;\n\n// ==========================================\n// 💻 DESKTOP COMPONENT RAIL FRAMEWORK\n// ==========================================\n.chat-container {\n  display: flex;\n  flex-direction: row;\n  height: 80vh; // Restored to full viewport height to align properly inside wrapper\n  width: auto; // Let width auto-calculate based on remaining screen footprint\n  background-color: $gemini-bg-main;\n  font-family: $gemini-font;\n  color: $gemini-text-main;\n  overflow: hidden;\n\n  // Sidebar Workspace Drawer (Recents Column Panel)\n  .sidebar {\n    width: 280px;\n    padding: 16px 12px;\n    background: $gemini-bg-sidebar;\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    scrollbar-color: #ffffff #ffffff; \n    position: relative;\n    border-right: 1px solid $gemini-border-color;\n    flex-shrink: 0; \n    transition: transform 0.3s ease, visibility 0.3s ease; \n\n    .new-chat-btn {\n      margin-bottom: 24px;\n      width: fit-content;\n      padding: 12px 18px;\n      border-radius: 24px;\n      background: $gemini-bg-pill;\n      color: $gemini-text-main;\n      font-weight: 500;\n      font-size: 14px;\n      border: 1px solid $gemini-border-color;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      transition: background-color 0.2s ease;\n\n      &:hover {\n        background-color: $gemini-bg-pill-hover;\n      }\n\n      span {\n        font-size: 20px;\n        line-height: 1;\n        color: $gemini-text-main;\n      }\n    }\n\n    .recent-header {\n      padding-left: 12px;\n      margin-bottom: 12px;\n\n      span {\n        font-weight: 500;\n        font-size: 13px;\n        color: $gemini-text-subtle;\n        letter-spacing: 0.01em;\n      }\n    }\n\n    .search-wrapper {\n      position: relative;\n      margin-bottom: 16px;\n      padding: 0 4px;\n\n      .search-input {\n        width: 100%;\n        padding: 10px 16px;\n        border-radius: 20px;\n        border: 1px solid $gemini-border-color;\n        background-color: transparent;\n        font-size: 14px;\n        color: $gemini-text-main;\n        outline: none;\n        box-sizing: border-box;\n\n        &::placeholder {\n          color: $gemini-text-subtle;\n          opacity: 0.7;\n        }\n      }\n    }\n\n    .heads-container {\n      flex: 1;\n      color: $gemini-text-main;\n\n      * {\n        color: $gemini-text-main !important;\n        background-color: transparent !important;\n      }\n    }\n  }\n\n  // Interaction Canvas\n  .chat-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    position: relative;\n    background: $gemini-bg-main;\n    min-width: 0; \n\n    &.is-empty {\n      justify-content: center; \n\n      .timeline-stream {\n        display: none !important; \n      }\n\n      .action-hub {\n        padding-top: 0;\n        .landing-welcome-hero {\n          display: block; \n        }\n      }\n    }\n\n    &:not(.is-empty) {\n      justify-content: space-between; \n\n      .timeline-stream {\n        display: flex; \n      }\n\n      .action-hub {\n        .landing-welcome-hero {\n          display: none !important; \n        }\n      }\n    }\n\n    .top-navbar {\n      background: rgba(255, 255, 255, 0.9);\n      backdrop-filter: blur(12px);\n      padding: 12px 24px;\n      z-index: 10;\n      color: $gemini-text-main;\n      flex-shrink: 0;\n\n      * {\n        color: $gemini-text-main !important;\n      }\n    }\n\n    .timeline-stream {\n      flex: 1;\n      position: relative;\n      background: $gemini-bg-main;\n      overflow-y: auto;\n      display: flex;\n      justify-content: center;\n\n      .reading-track {\n        width: 100%;\n        max-width: 820px;\n        padding: 24px 24px;\n\n        .message-text {\n          font-size: 16px;\n          line-height: 1.62;\n          color: $gemini-text-main;\n        }\n\n        span, a, div, p {\n          color: $gemini-text-main !important;\n        }\n        \n        a {\n          text-decoration: underline;\n          opacity: 0.9;\n        }\n      }\n    }\n\n    .action-hub {\n      background: $gemini-bg-main;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      padding-bottom: 24px;\n      padding-top: 8px;\n      width: 100%;\n      flex-shrink: 0;\n\n      .landing-welcome-hero {\n        display: none; \n        text-align: center;\n        margin-bottom: 24px;\n        max-width: 680px;\n        padding: 0 24px;\n        animation: heroFadeIn 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);\n\n        h1 {\n          font-size: 32px;\n          font-weight: 500;\n          color: $gemini-text-main;\n          margin-bottom: 12px;\n          letter-spacing: -0.02em;\n        }\n\n        .subtitle-suggestion {\n          font-size: 14px;\n          color: $gemini-text-subtle;\n          line-height: 1.5;\n          background: $gemini-bg-pill;\n          padding: 10px 16px;\n          border-radius: 16px;\n          display: inline-block;\n          border: 1px solid $gemini-border-color;\n        }\n      }\n\n      .input-max-width {\n        width: 100%;\n        max-width: 820px;\n        padding: 0 24px;\n        box-sizing: border-box;\n      }\n\n      .upload-pills {\n        margin-bottom: 12px;\n        display: flex;\n        gap: 12px;\n        flex-wrap: wrap;\n        padding: 12px;\n        background: $gemini-bg-pill;\n        border-radius: 16px;\n        border: 1px solid $gemini-border-color;\n\n        .file-preview {\n          display: flex;\n          flex-direction: column;\n          align-items: center;\n          position: relative;\n          max-width: 80px;\n\n          img, video {\n            width: 64px;\n            height: 64px;\n            object-fit: cover;\n            border-radius: 12px;\n            border: 1px solid $gemini-border-color;\n          }\n\n          .file-name {\n            font-size: 11px;\n            color: $gemini-text-subtle;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            width: 100%;\n            text-align: center;\n            margin-top: 6px;\n          }\n        }\n      }\n\n      .input-wrapper {\n        position: relative;\n        border-radius: 28px; \n        background-color: $gemini-bg-pill; \n        padding: 8px 16px;\n        color: $gemini-text-main;\n        border: 1px solid $gemini-border-color;\n        box-sizing: border-box;\n        \n        * {\n          color: $gemini-text-main !important;\n          fill: $gemini-text-main !important;\n        }\n        \n        input, textarea {\n          color: $gemini-text-main !important;\n          background-color: transparent !important;\n          \n          &::placeholder {\n            color: $gemini-text-subtle !important;\n            opacity: 0.6;\n          }\n        }\n      }\n\n      .footer-disclaimer {\n        text-align: center;\n        font-size: 12px;\n        color: $gemini-text-subtle;\n        margin-top: 12px;\n        letter-spacing: 0.01em;\n        opacity: 0.8;\n      }\n    }\n  }\n\n  // ==========================================\n  // 📱 MOBILE & TABLET RESPONSIVE ENGINE (< 768px)\n  // ==========================================\n  @media (max-width: 768px) {\n    padding-top: 56px; // Offset for top horizontal navbar height if it overlaps\n    height: calc(100vh - 56px);\n\n    .sidebar {\n      position: absolute;\n      top: 0;\n      left: 0;\n      height: 100%;\n      z-index: 100;\n      transform: translateX(-100%); \n      visibility: hidden;\n      box-shadow: 4px 0 24px rgba(0, 0, 0, 0.08);\n\n      &.is-open {\n        transform: translateX(0);\n        visibility: visible;\n      }\n    }\n\n    .chat-content {\n      .top-navbar {\n        padding: 12px 16px; \n      }\n\n      .timeline-stream {\n        .reading-track {\n          padding: 16px 16px; \n\n          .message-text {\n            font-size: 15px; \n          }\n        }\n      }\n\n      .action-hub {\n        padding-bottom: 16px;\n\n        .landing-welcome-hero {\n          padding: 0 16px;\n          \n          h1 {\n            font-size: 24px; \n          }\n        }\n\n        .input-max-width {\n          padding: 0 12px; \n        }\n      }\n    }\n  }\n}\n\n@keyframes heroFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.reading-track {\n  width: 100%;\n  max-width: 820px;\n  padding: 24px 24px;\n\n  @media (max-width: 768px) {\n    padding: 16px 16px;\n  }\n\n  .markdown-content {\n    font-size: 16px;\n    line-height: 1.65;\n    color: $gemini-text-main;\n\n    @media (max-width: 768px) {\n      font-size: 15px; \n    }\n\n    p {\n      margin-top: 0;\n      margin-bottom: 12px;\n    }\n\n    strong {\n      font-weight: 600;\n      color: #000000;\n    }\n\n    ul, ol {\n      margin-top: 4px;\n      margin-bottom: 12px;\n      padding-left: 20px; \n      \n      li {\n        margin-bottom: 6px;\n      }\n    }\n\n    ul {\n      list-style-type: disc;\n    }\n\n    ol {\n      list-style-type: decimal;\n    }\n    \n    code {\n      font-family: monospace;\n      background-color: $gemini-bg-pill;\n      padding: 2px 6px;\n      border-radius: 4px;\n      font-size: 13px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
